module.exports = __webpack_public_path__ + "static/media/fdi-leaflet.3c21d15d.png";